import React, { useEffect } from "react";
import sal from "sal.js";

// Every RevealAnimation instance calls sal() on mount to (re)scan the page
// for data-sal elements. When many instances mount in the same pass (a
// section with 10+ reveal cards), that's 10+ full-document rescans back to
// back. Coalescing same-frame mounts into a single sal() call keeps the
// exact same outcome - all elements observed once everything has mounted -
// without the redundant rescans.
let salScanScheduled = false;
const scheduleSal = () => {
  if (salScanScheduled) return;
  salScanScheduled = true;
  requestAnimationFrame(() => {
    salScanScheduled = false;
    sal();
  });
};

// animation:
//     | "fade"
//     | "slide-up"
//     | "slide-down"
//     | "slide-right"
//     | "slide-left"
//     | "zoom-in"
//     | "zoom-out"
//     | "flip-up"
//     | "flip-down"
//     | "flip-left"
//     | "flip-right"

function RevealAnimation({
  className,
  animation = "slide-left",
  duration = 1000,
  delay = 100,
  children,
  component,
  style = {},
  ...rest
}) {
  const Component = component || "div";

  useEffect(() => {
    scheduleSal();
  }, []);

  return (
    <Component
      className={className}
      data-sal={animation}
      data-sal-duration={duration.toString()}
      data-sal-delay={delay.toString()}
      data-sal-easing="ease"
      style={style}
      {...rest}
    >
      {children}
    </Component>
  );
}

export default RevealAnimation;
